var _path, _polygon, _path2, _path3, _circle, _path4, _path5, _polygon2, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _path16, _path17, _polygon3, _path18, _circle4, _path19, _path20, _path21, _circle5, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae61722e-c8df-4f74-981e-cb59bb83fec6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 910.91003,
    height: 603,
    viewBox: "0 0 910.91003 603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.905,372l-16-10,9.83271-24.96a13.43822,13.43822,0,0,1,11.79675-8.49422h0a13.43824,13.43824,0,0,1,11.3138,21.66994Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#feb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "299.193 493.934 277.164 484.381 289.117 459.779 306.908 470.19 299.193 493.934",
    fill: "#feb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.18683,681.76275l-25.33894-25.842a13.03585,13.03585,0,0,1,.0602-18.37489l12.7571-12.7571a4.15894,4.15894,0,0,1,6.63223.99043c3.14046,6.10431,7.41813,9.39549,12.95841,9.56309,3.32112.10047,3.84447-.02342,4.70927,3.1847l-1.06649,24.17377,4.38336,4.988a10.32366,10.32366,0,0,1,.07068,13.54831l0,0A10.32365,10.32365,0,0,1,435.18683,681.76275Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.905,623l-23-11,19-120-92.8823,7.74019c-29.367,2.44725-53.60725-23.81476-47.65485-52.67614A37.28968,37.28968,0,0,1,321.905,425l92,11,59.60977,8.19634a29.52782,29.52782,0,0,1,24.81513,22.90446v0a29.52778,29.52778,0,0,1-.37722,14.21657Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.85999,
    cy: 458,
    r: 145,
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.905,356l23,11-36.59113,60.114a15.65674,15.65674,0,0,1-15.69651,7.34285h0a15.65677,15.65677,0,0,1-12.62823-10.835L430.1146,345.44078a20.89473,20.89473,0,0,1,11.6346-29.4097h.00005A20.89473,20.89473,0,0,1,468.503,329.3016L487.905,389Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412.3177,326.67926c7.50915,1.04054,15.222-1.43462,21.48825-5.70125s11.2184-10.2135,15.41041-16.52993a107.10987,107.10987,0,0,0,15.0811-35.04346,20.54186,20.54186,0,0,0,20.01613,6.9641c11.92314-2.67683,19.07358-16.58822,16.748-28.58481s-12.16763-21.50773-23.399-26.3225-23.7483-5.61017-35.9682-5.583c-8.05771.01794-16.26963.39369-23.83862,3.15729s-14.50315,8.27162-17.19206,15.86747c-1.68579,4.76216-1.63078,10.03311-3.54756,14.70707-3.47982,8.48533-12.50539,13.11909-20.97589,16.63482s-17.679,7.08618-22.6742,14.77759c-5.6408,8.68549-4.0128,20.80738,2.20328,29.0909s16.19964,13.08654,26.35947,15.09506,20.62679,1.51185,30.97094,1.0069",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.193 493.934 242.164 484.381 254.117 459.779 271.908 470.19 264.193 493.934",
    fill: "#feb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400.18683,681.76275l-25.33894-25.842a13.03585,13.03585,0,0,1,.0602-18.37489l12.7571-12.7571a4.15894,4.15894,0,0,1,6.63223.99043c3.14046,6.10431,7.41813,9.39549,12.95841,9.56309,3.32112.10047,3.84447-.02342,4.70927,3.1847l-1.06649,24.17377,4.38336,4.988a10.32366,10.32366,0,0,1,.07068,13.54831l0,0A10.32365,10.32365,0,0,1,400.18683,681.76275Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M414.905,629l-23-11,19-120-92.8823,7.74019c-29.367,2.44725-53.60725-23.81476-47.65485-52.67614A37.28968,37.28968,0,0,1,283.905,431l92,11,59.60977,8.19634a29.52782,29.52782,0,0,1,24.81513,22.90446v0a29.52778,29.52778,0,0,1-.37722,14.21657Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.85999,
    cy: 116,
    r: 36.5,
    fill: "#feb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M422.905,350l-15-41c10.651-11.30188,12.99621-25.17093,9-41l43,24Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#feb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M392.905,447c-26.698,8.91085-62.02973,5.99544-106.29892-9.1625a7.77837,7.77837,0,0,1-3.36911-12.39936c29.85848-35.09611,56.64722-69.4698,78.75421-102.74155a58.15219,58.15219,0,0,1,33.5308-21.22227L415.905,297l31,16,8.12434,4.592a16.2167,16.2167,0,0,1,5.70183,22.824C448.28326,370.82919,432.058,398.59494,403.905,418Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M449.25123,257.39846a39.22217,39.22217,0,0,0,19.01065,15.68906c5.56558,2.14324,12.62772,2.67575,16.805-1.58093,3.026-3.0835,3.62924-7.82916,3.19985-12.128-1.34027-13.41827-11.42519-25.103-23.93794-30.13062s-26.958-3.92859-39.44548,1.1615c-11.782,4.80252-22.97149,14.64127-23.60533,27.34866-.32483,6.5122,2.0332,13.683-1.46262,19.18691-2.63288,4.14532-7.71813,5.82967-12.27289,7.66538s-9.44317,4.73238-10.37812,9.55333c-.63553,3.277.832,6.69743,3.13624,9.11263a24.743,24.743,0,0,0,8.4245,5.28194c7.42792,3.163,15.60472,5.13479,23.58489,3.912s15.69683-6.08247,18.81993-13.52724c2.40505-5.73308,1.91232-12.20256,1.63467-18.41347s-.19342-12.82566,3.12277-18.08449,11.01534-8.20291,15.9712-4.449",
    transform: "translate(-144.54498 -148.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.405,362.5s29,72,36,76,7-5.99213,7-5.99213Z",
    transform: "translate(-144.54498 -148.5)",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M588.02733,339.02745l-176.01128,28.633a3.30619,3.30619,0,0,1-3.7897-2.72922l-7.10263-43.66088a3.30619,3.30619,0,0,1,2.72922-3.7897l176.01128-28.633a3.3062,3.3062,0,0,1,3.78971,2.72922l7.10262,43.66088A3.30619,3.30619,0,0,1,588.02733,339.02745Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#536dfe"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.20572,
    cy: 190.35871,
    r: 13.8697,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M460.88282,324.58889a2.31162,2.31162,0,1,0,.74233,4.56325l107.56226-17.49793a2.31161,2.31161,0,1,0-.74234-4.56324Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M463.10983,338.27863a2.31162,2.31162,0,1,0,.74233,4.56325L571.41442,325.344a2.31162,2.31162,0,0,0-.74234-4.56325Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M459.905,389l-16-10,9.83271-24.96a13.43822,13.43822,0,0,1,11.79675-8.49422h0a13.43824,13.43824,0,0,1,11.3138,21.66994Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#feb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M443.905,373l23,11-36.59113,60.114a15.65674,15.65674,0,0,1-15.69651,7.34285h0a15.65677,15.65677,0,0,1-12.62823-10.835L361.1146,362.44078a20.89473,20.89473,0,0,1,11.6346-29.4097h.00005A20.89473,20.89473,0,0,1,399.503,346.3016L418.905,406Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.915,589.55c-13.25,18.73-16.75,125.33-17.53,159.5-.02.77-.04,1.5-.05,2.19h-33.54c-.41-.73-.79-1.45-1.15-2.19-19.88-39.24-8.85-86.29-8.27-88.67-1.51,7.48,5.32,29.16,13.04,50.16C976.12494,645.97,1016.395,592.81,1018.915,589.55Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "910.91 600.55 910.51 602.74 0 602.74 0 600.55 910.91 600.55",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M974.4758,344.67378H704.47531a5.00589,5.00589,0,0,1-5-5V272.69819a5.00588,5.00588,0,0,1,5-5H974.4758a5.00589,5.00589,0,0,1,5,5v66.97559A5.00589,5.00589,0,0,1,974.4758,344.67378ZM704.47531,269.69819a3.00328,3.00328,0,0,0-3,3v66.97559a3.00328,3.00328,0,0,0,3,3H974.4758a3.00329,3.00329,0,0,0,3-3V272.69819a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.93033,
    cy: 157.68572,
    r: 21,
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M787.97531,292.18572a3.5,3.5,0,0,0,0,7h165a3.5,3.5,0,0,0,0-7Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M787.97531,313.18572a3.5,3.5,0,0,0,0,7h165a3.5,3.5,0,0,0,0-7Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M974.4758,456.67378H704.47531a5.00589,5.00589,0,0,1-5-5V384.69819a5.00588,5.00588,0,0,1,5-5H974.4758a5.00589,5.00589,0,0,1,5,5v66.97559A5.00589,5.00589,0,0,1,974.4758,456.67378ZM704.47531,381.69819a3.00328,3.00328,0,0,0-3,3v66.97559a3.00328,3.00328,0,0,0,3,3H974.4758a3.00329,3.00329,0,0,0,3-3V384.69819a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.93033,
    cy: 269.68572,
    r: 21,
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M787.97531,404.18572a3.5,3.5,0,0,0,0,7h165a3.5,3.5,0,0,0,0-7Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M787.97531,425.18572a3.5,3.5,0,0,0,0,7h165a3.5,3.5,0,0,0,0-7Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M839.47555,232.5a42,42,0,1,1,42-42A42.0475,42.0475,0,0,1,839.47555,232.5Zm0-82a40,40,0,1,0,40,40A40.04552,40.04552,0,0,0,839.47555,150.5Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#536dfe"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M856.04767,186.357h-12.429V173.92788a4.14309,4.14309,0,1,0-8.28618,0V186.357H822.90331a4.143,4.143,0,0,0,0,8.28606h12.42915v12.42915a4.14309,4.14309,0,0,0,8.28618,0V194.64309h12.429a4.143,4.143,0,1,0,0-8.28606Z",
    transform: "translate(-144.54498 -148.5)",
    fill: "#536dfe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkpost);
export default __webpack_public_path__ + "static/media/bulkpost.2981d8e60f13f73c769e328be86e4e8a.svg";
export { ForwardRef as ReactComponent };